module.exports = __webpack_public_path__ + "3fc206049fd0ef2c3a9b8931bc695272.jpg";